/**
 * Custom Discount Engine
 * Mirrored from Clarindon Jewellers theme
 */
(function() {
    function initDiscounts() {
        const container = document.getElementById('product-discount-container');
        if (!container) return;

        const productData = JSON.parse(document.getElementById('product-json-discounts').textContent);
        if (!productData) return;

        // Fetch rules from the AJAX view
        // We preserve URL parameters (like preview_theme_id) to ensure we fetch from the correct theme version
        const urlParams = new URLSearchParams(window.location.search);
        const fetchUrl = '/search?view=ajax-discounts&' + urlParams.toString();

        fetch(fetchUrl)
            .then(response => response.text())
            .then(text => {
                // Find the first [ and last ] to extract the JSON array, ignoring any Shopify wrappers
                const start = text.indexOf('[');
                const end = text.lastIndexOf(']');
                
                if (start === -1 || end === -1) {
                    throw new Error('No JSON array found in response');
                }

                const cleanJson = text.substring(start, end + 1);
                try {
                    return JSON.parse(cleanJson);
                } catch (e) {
                    console.error('JSON Parse Error. Cleaned Text:', cleanJson);
                    throw e;
                }
            })
            .then(rules => {
                const activeDiscount = findMatchingDiscount(productData, rules);
                if (activeDiscount) {
                    renderDiscount(container, activeDiscount);
                }
            })
            .catch(error => console.error('Error fetching discounts:', error));
    }

    function findMatchingDiscount(product, rules) {
        // Prepare tags for easier matching
        const productTags = product.tags.map(tag => tag.toLowerCase().trim());
        const productVendor = (product.vendor || "").toLowerCase().trim();
        const hasSale = product.compare_at_price > product.price;
        
        // Check for Pre-Order (Reference theme logic)
        let isEligible = true;
        // if (productTags.includes('pre-order') && productVendor !== 'garmin') {
        //     isEligible = false;
        // }

        if (!isEligible) return null;

        for (const rule of rules) {
            let match = false;
            const ruleVendor = (rule.vendor || "").toLowerCase().trim();

            // 1. Vendor Match (or empty for global)
            if (ruleVendor === "" || ruleVendor === productVendor) {
                match = true;
            }

            if (!match) continue;

            // 2. Sale Exclusion
            if (hasSale && !rule.allow_sale) {
                match = false;
            }

            if (!match) continue;

            // 3. Tag Exclusions
            if (rule.exclusions && match) {
                const exclusions = rule.exclusions.split(',').map(t => t.trim().toLowerCase());
                for (const tag of exclusions) {
                    if (tag && productTags.includes(tag)) {
                        match = false;
                        break;
                    }
                }
            }

            if (!match) continue;

            // 4. Required Tag
            if (rule.required_tag && match) {
                const required = rule.required_tag.trim().toLowerCase();
                if (!productTags.includes(required)) {
                    match = false;
                }
            }

            if (!match) continue;

            // 5. Limited Edition Exclusion
            if (rule.exclude_limited && match && productTags.includes('limited edition: yes')) {
                match = false;
            }

            if (!match) continue;

            // 6. Excluded Vendors (for global rules)
            if (rule.excluded_vendors && match && productVendor) {
                const excludedVendors = rule.excluded_vendors.split(',').map(v => v.trim().toLowerCase());
                if (excludedVendors.includes(productVendor)) {
                    match = false;
                }
            }

            if (match) {
                return rule;
            }
        }

        return null;
    }

    function renderDiscount(container, discount) {
        if (discount.image && discount.image !== "") {
            let html = `
                <div class="product-discount">
                    ${discount.link ? `<a href="${discount.link}" target="_blank" rel="noreferrer">` : ''}
                        <img class="product-discount__image" src="${discount.image}" alt="${discount.alt || ''}" width="700" height="145" loading="lazy">
                    ${discount.link ? `</a>` : ''}
                </div>
            `;
            container.innerHTML = html;
        } else {
            // New Premium Text-based banner
            const textColor = discount.textcolor || '#000000';
            const accentColor = '#A68037';
            
            let html = `
                <div class="product-discount-premium">
                    <div class="product-discount-premium__left">
                        <div class="product-discount-premium__icon-circle">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="${accentColor}" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                                <line x1="7" y1="7" x2="7.01" y2="7"></line>
                            </svg>
                        </div>
                    </div>
                    <div class="product-discount-premium__divider"></div>
                    <div class="product-discount-premium__content">
                        <div class="product-discount-premium__subtitle">${discount.subtitle || 'EXCLUSIVE ONLINE OFFER'}</div>
                        <div class="product-discount-premium__title">
                            Enjoy <span class="product-discount-premium__highlight">${discount.percent}${discount.percent.indexOf('%') === -1 ? '%' : ''} off</span> this order
                        </div>
                        <div class="product-discount-premium__footer">Use code ${discount.code} at checkout</div>
                    </div>
                    <div class="product-discount-premium__actions">
                        <div class="product-discount-premium__code-wrapper">
                            <div class="product-discount-premium__code">${discount.code}</div>
                            <button class="product-discount-premium__copy-btn" data-code="${discount.code}">Copy</button>
                        </div>
                        <div class="product-discount-premium__success" style="display: none;">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#28a745" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                <polyline points="20 6 9 17 4 12"></polyline>
                            </svg>
                            <span>Code copied</span>
                        </div>
                    </div>
                </div>
            `;
            container.innerHTML = html;

            // Add copy listener
            const copyBtn = container.querySelector('.product-discount-premium__copy-btn');
            const successMsg = container.querySelector('.product-discount-premium__success');
            
            if (copyBtn) {
                copyBtn.addEventListener('click', function() {
                    const code = this.getAttribute('data-code');
                    navigator.clipboard.writeText(code).then(() => {
                        successMsg.style.display = 'block';
                        this.innerText = 'Copied';
                        setTimeout(() => {
                            successMsg.style.display = 'none';
                            this.innerText = 'Copy';
                        }, 3000);
                    });
                });
            }
        }
        container.style.display = 'block';
    }

    // Run on load
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initDiscounts);
    } else {
        initDiscounts();
    }

    // Re-init on Shopify Section Load (Theme Editor)
    document.addEventListener('shopify:section:load', function(e) {
        if (e.detail.sectionId.includes('main-product')) {
            initDiscounts();
        }
    });
})();
